/**
 * QueryLogsClient
 * SignalR client for Query Logs Hub (/hubs/query-logs)
 * Handles real-time database query performance log streaming with filtering
 */
import { BaseLogsClient } from './BaseLogsClient';
/**
 * Query logs hub client
 */
export class QueryLogsClient extends BaseLogsClient {
    constructor(baseUrl, getToken, options = {}) {
        const hubUrl = `${baseUrl}/hubs/query-logs`;
        super(hubUrl, getToken, options);
    }
    /**
     * Setup server-side method handlers
     */
    setupServerMethods() {
        if (!this.connection)
            return;
        // Receive real-time query log entries
        this.connection.on('ReceiveQueryLog', (log) => {
            this.addLogToBuffer(log);
            this.emit('log', log);
        });
    }
    /**
     * Subscribe to query logs with filter
     */
    async subscribe(filter = {}) {
        this.currentFilter = filter;
        await this.invoke('SubscribeToQueryLogs', filter.serviceNames || [], filter.minDurationMs || null, filter.slowOnly || null);
        this.isSubscribed = true;
    }
    /**
     * Unsubscribe from query logs
     */
    async unsubscribe() {
        await this.invoke('UnsubscribeFromQueryLogs');
        this.isSubscribed = false;
        this.currentFilter = null;
    }
    /**
     * Get recent query logs
     */
    async getRecent(limit = 100) {
        return await this.invoke('GetRecentQueryLogs', limit);
    }
}
//# sourceMappingURL=QueryLogsClient.js.map